<template>
  <div
    class="flex items-center space-x-2"
    v-if="safeVersion || tooltip || icon"
    v-tooltip.left="tooltip || ''"
  >
    <i
      :class="icon || 'pi pi-database'"
      :style="{ color: iconColor }"
      style="font-size: 1rem"
    ></i>
    <span class="font-regular text-sm text-gray-500">v{{ safeVersion }}</span>
  </div>
</template>

<script>
  import { defineComponent, computed } from "vue";

  export default defineComponent({
    name: "DynamicVersionDisplayComponent",
    props: {
      tooltip: String,
      version: [String, Number],
      icon: String,
      iconColor: { type: String, default: "gray" }
    },
    setup(props) {
      const safeVersion = computed(() =>
        !isNaN(Number(props.version)) ? props.version : 1
      );
      return { safeVersion };
    }
  });
</script>
